<template>
  <ModalBase :show-modal="true" auto-h @close-modal="close" class="import-to-invoice-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ $gettext('ADD ITEMS') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Import to invoice') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <div class="import-to-invoice-modal-content">
        <b-tabs class="gk-tabs import-to-invoice-tabs" lazy>
            <b-tab :title="$gettext('Costs')" :active="importType === 'costs'" @click="importType = 'costs'">
              <div class="import-tab-form">
                <ImportCostsToInvoice
                  :invoice-lines="(isQuotation) ? invoice.quotationline_set : invoice.invoice_lines"
                  :is-quotation="isQuotation"
                  :filter-cookie-name="'costs-' + filterCookieName"
                  @close="close"
                  @add-lines="addLines"
                />
              </div>
            </b-tab>

            <b-tab :title="$gettext('Hours')" :active="importType === 'hours'" @click="importType = 'hours'">
              <div class="import-tab-form">
                <ImportHoursToInvoice
                  :invoice-lines="(isQuotation) ? invoice.quotationline_set : invoice.invoice_lines"
                  :is-quotation="isQuotation"
                  :filter-cookie-name="'hours-' + filterCookieName"
                  @close="close"
                  @add-lines="addLines"
                />
              </div>
            </b-tab>

            <b-tab :title="$gettext('Trips')" :active="importType === 'trips'" @click="importType = 'trips'">
              <div class="import-tab-form">
                <ImportTripsToInvoice
                  :invoice="invoice"
                  :is-quotation="isQuotation"
                  :filter-cookie-name="'trips-' + filterCookieName"
                  @close="close"
                  @add-lines="addLines"
                />
              </div>
            </b-tab>

            <b-tab :title="$gettext('Products')" :active="importType === 'products'" @click="importType = 'products'">
              <div class="import-tab-form">
                <ImportProductsToInvoice
                  :invoice="invoice"
                  :is-quotation="isQuotation"
                  :filter-cookie-name="'products-' + filterCookieName"
                  @close="close"
                  @add-lines="addLines"
                />
              </div>
            </b-tab>

        </b-tabs>
      </div>

    </template>
  </ModalBase>

</template>

<script>
import { mapGetters } from "vuex";

import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import ImportCostsToInvoice from "@/components/invoices/ImportCostsToInvoice";
import ImportHoursToInvoice from "@/components/invoices/ImportHoursToInvoice";
import ImportTripsToInvoice from "@/components/invoices/ImportTripsToInvoice";
import ImportProductsToInvoice from "@/components/invoices/ImportProductsToInvoice";

export default {
  name: "ImportToInvoiceModal",
  components: {
    ModalBase,
    TitleBar,
    GekkoButton,
    LoadingSpinner,
    ImportCostsToInvoice,
    ImportHoursToInvoice,
    ImportTripsToInvoice,
    ImportProductsToInvoice
  },
  props: {
    invoice: {
      type: Object,
      default: () => {}
    },
    isQuotation: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      loading: true,
      importType: 'costs',
      filterCookieName: 'TempImportFilterOptionsVue2',
      agregationType: null,
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: "main/getCurrentCompany",
      selectedCustomer: "invoices/getInvoiceCreateRecipient",
      selectedProject: "invoices/getInvoiceCreateProject",
      getCompanyId: 'main/getCompanyId'
    })
  },
  watch: {
    importType (type) {
      let default_filters
      const date_from = new Date(this.invoice.invoice_date);
      date_from.setMonth(date_from.getMonth() - 1);
      switch (type) {
        case 'costs':
          default_filters = {
            option: 'custom_range',
            start_date: date_from.toISOString().split('T')[0],
            end_date: this.invoice.invoice_date,
            owner_company: this.getCompanyId
          }
          if (this.selectedProject) {
            default_filters.project = this.selectedProject.id
          }
          break;
        case 'hours':
          console.log('selectedCustomer', this.selectedCustomer)
          console.log('selectedProject', this.selectedProject)
          default_filters = {
            customer: this.selectedCustomer.id,
            option: 'custom_range',
            start_date: date_from.toISOString().split('T')[0],
            end_date: this.invoice.invoice_date,
          }
          if (this.selectedProject) {
            default_filters.project = this.selectedProject.id
          }
          break;
      }
      this.setModalCookie(default_filters)
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    document.body.classList.add('modal-on')

    if (this.$route.query.import === 'hours' ) {
      setTimeout(() => {
        this.importType = 'hours'
      }, 500); // TODO fix this
    }

    if (this.$route.query.import === 'trips' ) {
      setTimeout(() => {
        this.importType = 'trips'
      }, 500); // TODO fix this
    }

    if (this.$route.query.import === 'products' ) {
      setTimeout(() => {
        this.importType = 'products'
      }, 500); // TODO fix this
    }


  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    setupData () {
      this.setModalCookie()
    },
    setModalCookie (default_filters) {
      const date_from = new Date(this.invoice.invoice_date);
      date_from.setMonth(date_from.getMonth() - 1);

      let defaultFilters = {
        option: 'custom_range',
        start_date: date_from.toISOString().split('T')[0],
        end_date: this.invoice.invoice_date,
        owner_company: this.getCompanyId
      }
      if (this.selectedProject) {
        defaultFilters.project = this.selectedProject.id
      }

      if (default_filters) {
        defaultFilters = default_filters
      }

      var d1 = new Date (), expire = new Date ( d1 );
      expire.setMinutes ( d1.getMinutes() + 60 * 12 );
      this.$cookies.set(this.importType + '-' + this.filterCookieName + '-' + this.getCompanyId, defaultFilters, expire, '/');
    },
    addLines (lines) {

      console.log('lines to import', lines)
      
      let item_type_prop = ''
      switch (this.importType) {
        case 'costs':
          item_type_prop = 'cost_ids'
          break;
        case 'hours':
          item_type_prop = 'aggregated_hours'
          break;
        case 'trips':
          item_type_prop = 'trip_ids'
          break;
        case 'products':
          item_type_prop = 'product' // not an array
          break;
      }

      // determine if line should be imported based on item type and id
      let current_lines_of_type = []
      if (this.isQuotation) {
        current_lines_of_type = this.invoice.quotationline_set.filter(obj => Object.prototype.hasOwnProperty.call(obj, item_type_prop))
      } else {
        current_lines_of_type = this.invoice.invoice_lines.filter(obj => Object.prototype.hasOwnProperty.call(obj, item_type_prop))
      }

      let prevent_import = false
      for (let index = 0; index < lines.length; index++) {
        const line = lines[index];
        if (this.importType !== 'products') {
          if (current_lines_of_type.some(added_item => added_item[item_type_prop].some(id => line[item_type_prop].includes(id)))) {
            // should not add, some id already included in line
            prevent_import = true
            break;
          }
        } else {
          const existing_product_line = current_lines_of_type.find(added_item => added_item[item_type_prop] === line[item_type_prop])
          if (existing_product_line) {
            // update existing line multiplier and remove new line
            this.$set(existing_product_line, 'multiplier', line.multiplier)
            line.skip = true
          }
        }
      }
      if (!prevent_import) {
        const lines_to_import = lines.filter(obj => !Object.prototype.hasOwnProperty.call(obj, 'skip'))
        this.$emit('add-lines', lines_to_import)
        this.close()
      } else {
        this.$store.commit('setAlert', {
          title: this.$gettext('Could not import'),
          text: this.$gettext('Some elements are already imported'),
          variant: "warning",
          duration: 2
        })
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
.import-to-invoice-modal {
  font-size: 1rem;
  .gk-modal {
    margin-top: 0;
    .modal-content-wrap { position: relative; }
  }

  .import-to-invoice-modal-content {
    height: 100%;
    overflow: hidden;

    .import-to-invoice-tabs {
      height: 100%;
      display: flex;
      flex-direction: column;
      .tab-content {
        height: 100%;
        .os-host-overflow-y {
          padding-right: 1rem;
        }
      }
    }
  }
  .action-buttons-wrapper {
    &.has-actions {

    }
  }

}
</style>